import React from 'react';
import { useParams } from 'react-router-dom';
import axios from "axios";

const baseURL = "http://api.bit3.in/api/Link/GetOrgUrl?shortlinkcode=";

const RootComponent = () =>{
    const params = useParams();
    var ur='';
     axios.get(baseURL+ params.id  ).then((response) => {
     console.log(response.data.dro.resultValue1);

      if(response.data.actionStatusResult == 'Success')
     {
        ur = response.data.dro.resultValue1
         
         if(ur!='')
         window.location.href =  ur;
     }

    });
     
    return  <div className='subtitle1'> </div> 
     
   
 }

  
export default RootComponent;